export enum EventTypeEnum {
  Individual = 'INDIVIDUAL',
  Group = 'GROUP',
}

export enum EventDateRangeModeEnum {
  Range = 'RANGE',
  Indefinite = 'INDEFINITE',
  FarOutBookRange = 'FAR_OUT_BOOK_RANGE',
}

export const eventTypeLocoKeys = {
  [EventTypeEnum.Individual]: 'dashboard.calendar.event_type_individual_title',
  [EventTypeEnum.Group]: 'dashboard.calendar.event_type_group_title',
}

export const eventChooseTypeLocoKeys = {
  [EventTypeEnum.Individual]: 'dashboard.calendar.event_type_individual',
  [EventTypeEnum.Group]: 'dashboard.calendar.event_type_group',
}
